import './ImageSelect.scss';
import * as React from 'react';
import FileButton from 'src/components/Button/FileButton';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon';
import classNames from 'classnames';

const ImagePreview = (props: { file: File | null, url: string | null }) => {
  const source = React.useMemo(() => {
    if (props.file) {
      return URL.createObjectURL(props.file);
    }

    return props.url;
  }, [props.file, props.url]);

  return (
    <div
      className="absolute inset-0"
      style={{
        backgroundImage: source ? `url(${source})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
  );
};

export interface IImageSelectProps {
  imageUrl: string | null;
  imageFile: File | null;
  onRemoveImage: () => void;
  onImageFileChange: (imageFile: File | null) => void;
  showErrorBorder?: boolean;
}

const ImageSelect = (props: IImageSelectProps) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const handleSelectImage = React.useCallback((files: FileList) => {
    const image = files[0];

    if (image) {
      props.onImageFileChange(image);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

    }
  }, [props.onImageFileChange]);

  const handleRemoveImage = React.useCallback(() => {
    if (props.imageFile) {
      props.onImageFileChange(null);
    } else {
      props.onRemoveImage();
    }
  }, [props]);

  return (
    <div
      className={classNames(
        'has-background-gray-300 p-4 border',
        props.showErrorBorder && 'border-danger',
      )}
    >
      <div className="ThemeImagePreview relative">
        {(props.imageUrl || props.imageFile) && (
          <ImagePreview url={props.imageUrl} file={props.imageFile} />
        )}
      </div>
      <div className="mt-4 flex justify-between">
        {(props.imageFile || props.imageUrl) && (
          <Button
            color="danger"
            type="button"
            onClick={handleRemoveImage}
          >
            {props.imageFile ? 'Fjern nyt billede' : 'Fjern billede'}
            <Icon name="cross" className="ml2" />
          </Button>
        )}
        <FileButton
          className="ml-auto"
          accept="image/*"
          multiple={false}
          inputRef={fileInputRef}
          onSelect={handleSelectImage}
        >
          Vælg billede
        </FileButton>
      </div>
      <div className="text-center f5 has-text-gray-700 mt-5">
        NB - Billedet skal være minimum 780px * 370px.<br/>
        Billedet beskæres i enten højde eller bredde, hvis propertioner ikke passer.
      </div>
    </div>
  );
};

export default ImageSelect;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/ThemeSectionEditor/components/ImageSelect.tsx